import { render, staticRenderFns } from "./ClientSlider.vue?vue&type=template&id=d16c9092"
import script from "./ClientSlider.vue?vue&type=script&lang=js"
export * from "./ClientSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports